import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlacementSession } from '../../_models/tutor-reports/placement-session.model';

@Component({
    selector: 'session-overview-session-blocks',
    templateUrl: './session-overview-session-blocks.component.html',
    styleUrls: ['./session-overview-session-blocks.component.css'],
    standalone: false
})
export class SessionOverviewSessionBlocksComponent implements OnInit, AfterViewInit {
  @Input() availableSessionBlocks: Array<PlacementSession>;
  @Output() blocksRenderComplete = new EventEmitter<any>();

  private weekday: string[] = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"];

  public sessionBlocksCurrent: Array<PlacementSession> = new Array<PlacementSession>();
  public sessionBlocksFuture: Array<PlacementSession> = new Array<PlacementSession>();

  public hideFutureBlocks: boolean = true;

  constructor() { }

  ngOnInit() {
    this.populateTimeLockedSessionBlocks();
  }

  ngAfterViewInit() {        
    this.blocksRenderComplete.emit(true);
  } 

  public setDisplaySessionBlockDay(date: any): string {
    return this.weekday[new Date(date).getDay()];
  }

  private populateTimeLockedSessionBlocks(): void {
    let cutOffDate = new Date();
    cutOffDate.setDate(cutOffDate.getDate() + 5);
    cutOffDate.setHours(22, 0, 0, 0);

    this.sessionBlocksCurrent = this.availableSessionBlocks.filter(session => new Date(session.startDate) <= cutOffDate);
    this.sessionBlocksFuture = this.availableSessionBlocks.filter(session => new Date(session.startDate) > cutOffDate);
  }

}
